import {CitySlug} from "../../../../../config/cities";
import {IRegionAutocompleteItem} from "../../map/api/charts_regions_api";
import {IRecentMapRegionSearch, RecentMapRegionSearchInput} from "./recent_map_region_storage";

export type MapRegionSearchOption = {
    region: IRegionAutocompleteItem;
    citySlug: CitySlug | null;
    label: string;
    subtitle: string | null;
};

export const toMapRegionSearchOption = (
    region: IRegionAutocompleteItem,
    citySlug: CitySlug | null,
    label: string,
    subtitle: string | null
): MapRegionSearchOption => ({
    region,
    citySlug,
    label,
    subtitle
});

export const toRecentMapRegionSearchInput = (option: MapRegionSearchOption): RecentMapRegionSearchInput => ({
    regionId: option.region.id,
    slug: option.region.slug,
    type: option.region.type,
    hasChartsAccess: option.region.has_charts_access,
    label: option.label,
    subtitle: option.subtitle,
    citySlug: option.citySlug
});

export const recentMapRegionSearchToOption = (entry: IRecentMapRegionSearch): MapRegionSearchOption =>
    toMapRegionSearchOption(
        {
            id: entry.regionId,
            slug: entry.slug,
            type: entry.type,
            has_charts_access: entry.hasChartsAccess,
            name: entry.label,
            full_name_reverted: entry.subtitle,
            short_name: entry.subtitle
        },
        entry.citySlug,
        entry.label,
        entry.subtitle
    );
